var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70005 4.57561C8.10051 4.57561 8.42514 4.90024 8.42514 5.3007V11.1014C8.42514 11.5018 8.10051 11.8264 7.70005 11.8264C7.2996 11.8264 6.97497 11.5018 6.97497 11.1014V5.3007C6.97497 4.90024 7.2996 4.57561 7.70005 4.57561Z",
    fill: "#0050AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.07464 8.20103C4.07464 7.80058 4.39927 7.47595 4.79972 7.47595H10.6004C11.0008 7.47595 11.3255 7.80058 11.3255 8.20103C11.3255 8.60148 11.0008 8.92611 10.6004 8.92611H4.79972C4.39927 8.92611 4.07464 8.60148 4.07464 8.20103Z",
    fill: "#0050AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70005 2.40036C4.49643 2.40036 1.89939 4.99741 1.89939 8.20103C1.89939 11.4047 4.49643 14.0017 7.70005 14.0017C10.9037 14.0017 13.5007 11.4047 13.5007 8.20103C13.5007 4.99741 10.9037 2.40036 7.70005 2.40036ZM0.449219 8.20103C0.449219 4.19651 3.69553 0.950195 7.70005 0.950195C11.7046 0.950195 14.9509 4.19651 14.9509 8.20103C14.9509 12.2056 11.7046 15.4519 7.70005 15.4519C3.69553 15.4519 0.449219 12.2056 0.449219 8.20103Z",
    fill: "#0050AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.13ad0faea7a31d89bc8ed576ed012b23.svg";
export { ForwardRef as ReactComponent };